var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding":"40px"}},[_c('hi-media-caption'),_c('hi-media-caption',{attrs:{"active":true}}),_c('hi-media-caption',{attrs:{"date":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }